export const getWhatsappMessageLink = message => {
  return `https://wa.me/918006888600?text=${encodeURIComponent(message)}`;
};
